export default __webpack_public_path__ + "static/media/banner.7c445007.webm";